export default function grilleNotationData(grille = [], action) {
    if (action.type === 'grilleNotation') {
        const newGrille = action.grille;
        return newGrille;
    }

    return grille;
}
